import React, { forwardRef, useImperativeHandle } from 'react';

// Styles
import './popup-settings-tab.scss';

// Components
import { SettingsBlock } from '../settings-block/settings-block';
import { PreviewBlock } from '../preview-block/preview-block';
import { WidgetCodeBlock } from '../widget-code-block/widget-code-block';

// Models
import { IWidgetInfo } from '../../../../../../interfaces/widget-settings.interfaces';

export type TPopupSettingsTabRef = {};

type TPopupSettingsTabProps = {
  widget_settings: IWidgetInfo;
  loading: boolean;
};

export const PopupSettingsTab = forwardRef<TPopupSettingsTabRef, TPopupSettingsTabProps>(
  ({ widget_settings, loading }: TPopupSettingsTabProps, ref
  ) => {

    useImperativeHandle(ref, () => ({}));

    return (
      <div className="popup-settings-tab">
        <div className="popup-settings-tab--column">
          <SettingsBlock widget_settings={ widget_settings } type={ 'popup' } loading={ loading }/>
          <WidgetCodeBlock widget_settings={ widget_settings } type={ 'popup' }/>
        </div>
        <div className="popup-settings-tab--column">
          <PreviewBlock type={ 'popup' } widget_settings={ widget_settings }/>
        </div>
      </div>
    );
  })
